export enum BpcPartner {
  Unspecified = 0,
  Kynetec = 1,
  JohnDeere = 2,
}

export enum DropletSize {
  Unspecified = 0,
  ExtremelyFine = 1,
  VeryFine = 2,
  Fine = 3,
  Medium = 4,
  Coarse = 5,
  VeryCoarse = 6,
  ExtremelyCoarse = 7,
  UltraCoarse = 8,
}

export interface IInputUnit {
  unit: string;
  globalId: string | null;
}

export interface IInputNozzle {
  nozzleSize: string | null;
  brand: string | null;
  model: string | null;
  dropletSize: DropletSize;
  sprayQuality: string | null;
  pressure: number | null;
  pressureUnit: IInputUnit | null;
}

export interface IOrganisationSettings {
  startMonth: number;
  nozzles: IInputNozzle[];
  waterRate: number | null;
}

export interface IUserAccess {
  userId: string;
  access: number;
}

export interface ITeamAccess {
  teamId: string;
  userAccesses: IUserAccess[];
}

// Organisation : ServiceCollection : BaseCollection — full read document.
export interface IOrganisation {
  id: string;
  version: number;
  dateCreated: string;
  creatorId: string | null;
  snapCreator: string | null;
  dateModified: string;
  modifierId: string | null;
  snapModifier: string | null;
  sourceId: string;
  isActive: boolean;
  orgId: string;
  partner: BpcPartner;
  partnerId: string | null;
  orgName: string;
  firstName: string | null;
  lastName: string | null;
  preferredName: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  postcode: string | null;
  country: string | null;
  phone: string | null;
  fax: string | null;
  mobile: string | null;
  email: string | null;
  abn: string | null;
  notes: string | null;
  orgSetting: IOrganisationSettings;
  userAccesses: IUserAccess[];
  teamAccesses: ITeamAccess[];
  lastChangeId: string | null;
}

export type OrganisationWithExtras = IOrganisation & {
  formattedAddress: string;
  contactName: string;
  _searchText?: string;
};

export interface ICreateOrganisationRequest {
  id: string;
  orgId: string;
  sourceId: string;
  isActive: boolean;
  partner: BpcPartner;
  orgName: string;
  partnerId?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  country?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
  email?: string | null;
  mobile?: string | null;
  phone?: string | null;
  fax?: string | null;
  abn?: string | null;
  notes?: string | null;
  orgSetting: IOrganisationSettings;
  userAccesses: IUserAccess[];
}

export type IUpdateOrganisationRequest = ICreateOrganisationRequest;
